

const dev = {
    backendUrl: 'http://localhost:3000/',
    newCrmUrl: 'https://crm-mono.development.superbikefactory.co.uk',
    leadServiceUrl: 'http://localhost:3010',
    identityServiceUrl: 'http://localhost:3012',
    magento: 'https://magento.development.superbikefactory.co.uk/api/v1',
    bikelookup: 'https://staging.bikelookup.superbikefactory.co.uk/api/v1',
    featureToggles: {
        globalAuth: false,
        leadBlemishReport: true,
    },
};

const development = {
    backendUrl: 'https://development.connect.superbikefactory.co.uk/',
    newCrmUrl: 'https://crm-mono.development.superbikefactory.co.uk',
    leadServiceUrl: 'https://leads-mono.development.superbikefactory.co.uk',
    identityServiceUrl: 'https://identity-service-mono.development.superbikefactory.co.uk',
    magento: 'https://magento.development.superbikefactory.co.uk/api/v1',
    bikelookup: 'https://staging.bikelookup.superbikefactory.co.uk/api/v1',
    featureToggles: {
        globalAuth: false,
        leadBlemishReport: true,
    },
};

const staging = {
    backendUrl: 'https://staging.connect.superbikefactory.co.uk/',
    newCrmUrl: 'https://crm-mono.staging.superbikefactory.co.uk',
    leadServiceUrl: 'https://leads-mono.staging.superbikefactory.co.uk',
    identityServiceUrl: 'https://identity-service-mono.staging.superbikefactory.co.uk',
    magento: 'https://magento.staging.superbikefactory.co.uk/api/v1',
    bikelookup: 'https://staging.bikelookup.superbikefactory.co.uk/api/v1',
    featureToggles: {
        globalAuth: false,
        leadBlemishReport: true,
    },
};

const preprod = {
    backendUrl: 'https://connect-preprod.superbikefactory.co.uk/',
    newCrmUrl: 'https://crm-mono.superbikefactory.co.uk',
    leadServiceUrl: 'https://leads-mono.superbikefactory.co.uk',
    identityServiceUrl: 'https://identity-service-mono.superbikefactory.co.uk',
    featureToggles: {
        globalAuth: false,
        leadBlemishReport: true,
    },
};

const prod = {
    backendUrl: 'https://connect.superbikefactory.co.uk/',
    newCrmUrl: 'https://crm-mono.superbikefactory.co.uk',
    leadServiceUrl: 'https://leads-mono.superbikefactory.co.uk',
    identityServiceUrl: 'https://identity-service-mono.superbikefactory.co.uk',
    magento: 'https://magento.superbikefactory.co.uk/api/v1',
    bikelookup: 'https://bikelookup.superbikefactory.co.uk/api/v1',
    featureToggles: {
        globalAuth: false,
        leadBlemishReport: true,
    },
};

// WeBuyAnyBike production (webuyanybike.com)
const wbab = {
    backendUrl: 'https://api.webuyanybike.com/',
    newCrmUrl: 'https://crm-mono.superbikefactory.co.uk',
    leadServiceUrl: 'https://leads.webuyanybike.com',
    identityServiceUrl: 'https://identity.webuyanybike.com',
    magento: 'https://intake.webuyanybike.com/api/v1',
    // bikelookup DNS/TLS is not yet live in gordonbrothers — pending separate follow-up.
    bikelookup: 'https://bikelookup.superbikefactory.co.uk/api/v1',
    featureToggles: {
        globalAuth: false,
        leadBlemishReport: true,
    },
};

let config = dev;

if (process.env.API_ENV === 'wbab') {
    config = wbab;
} else if (process.env.API_ENV === 'production') {
    config = prod;
} else if (process.env.API_ENV === 'preprod') {
    config = preprod;
} else if (process.env.API_ENV === 'staging') {
    config = staging;
} else if (process.env.API_ENV === 'development') {
    config = development;
} else if (process.env.API_ENV === 'local') {
    config = dev;
}

// config = dev;

if (process.env.SETTINGS !== undefined) {
    if (process.env.SETTINGS === 'test') {
        config = staging;
    }
}

export default {
    ...config,
};



// WEBPACK FOOTER //
// ./src/config/sbf_config.js